export default __webpack_public_path__ + "static/media/barco-pirata.6e92031d.png";